// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"5176cc17","458":"4c900a9a","576":"53145242","829":"5a43b13a"}[chunkId] + ".chunk.css";
};